import { render, staticRenderFns } from "./position-list.vue?vue&type=template&id=5960c04a&scoped=true&"
import script from "./position-list.vue?vue&type=script&lang=js&"
export * from "./position-list.vue?vue&type=script&lang=js&"
import style0 from "./position-list.vue?vue&type=style&index=0&id=5960c04a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5960c04a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5960c04a')) {
      api.createRecord('5960c04a', component.options)
    } else {
      api.reload('5960c04a', component.options)
    }
    module.hot.accept("./position-list.vue?vue&type=template&id=5960c04a&scoped=true&", function () {
      api.rerender('5960c04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/extra_cost/form/position-list.vue"
export default component.exports